(function($) {
    "use strict";
    $('.element .element_container_parent').on('click', function(e) {
        e.preventDefault();
        var itemId = $(this).attr('id');
        $('.mi_dropdown').hide();
        $('#' + itemId + '_dropdown').fadeIn('slow')
    });
    $('.mi_dropdown_dismiss').on('click', function(e) {
        e.preventDefault();
        var getItem = $(this).attr('dismiss-target');
        $('#' + getItem).hide()
    });
    var default_srcs = {
        'sleeves': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-short.png?v=1678270215',
        'collar': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-classic.png?v=1678270216',
        'cuff': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/straight-one.jpg?v=1678348751',
        'pocket': 'nan',
        'placket': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-white_9006e10d-25ec-482c-9421-b11efc4f37bc.png?v=1678347778',
        'back': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-no-pleats.png?v=1678270215',
        'back_type': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-short.png?v=1678270215',
        'bottom': 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-square.png?v=1678348674'
    };

    function design_shirt(paths) {
        $('.custom_shirt.shirt_collar').attr('src', paths.collar);
        $('.custom_shirt.shirt_placket').attr('src', paths.placket);
        $('.custom_shirt.shirt_pocket').attr('src', paths.pocket);
        $('.custom_shirt.shirt_sleeves').attr('src', paths.sleeves);
        $('.custom_shirt.shirt_cuff_all').attr('src', paths.cuff);
        $('.custom_shirt.shirt_back_base').attr('src', paths.back);
        $('.custom_shirt.shirt_back_short').attr('src', paths.back_type);
        $('.custom_shirt.shirt_back_tail').attr('src', paths.bottom)
    }
    design_shirt(default_srcs);
    var default_data = {
        mi_selected_sleeve: 'Short Sleeve',
        mi_selected_cuff: 'N/A',
        mi_selected_collar: 'Classic Collar',
        mi_selected_pocket: 'No Pocket',
        mi_selected_placket: 'White Placket',
        mi_selected_back: 'No Pleats',
        mi_selected_bottom: 'Tail Bottom',
        mi_selected_fabric: 'Cloth - 1',
        mi_selected_fits: 'Slim Fit',
        mi_selected_tall: '5 Feet - 1 Inch',
        mi_selected_weight: '50 Kg',
        mi_selected_collar_size: '10 Inch',
        mi_total_price: 'Rs 2,000',
    };

    function get_total_data(data) {
        $('.design_shower').html('<p>Sleeve: <span class="float-right">' + data.mi_selected_sleeve + '</span></p>' + '<p>Cuff: <span class="float-right">' + data.mi_selected_cuff + '</span></p>' + '<p>Collar: <span class="float-right">' + data.mi_selected_collar + '</span></p>' + '<p>Pocket: <span class="float-right">' + data.mi_selected_pocket + '</span></p>' + '<p>Placket: <span class="float-right">' + data.mi_selected_placket + '</span></p>' + '<p>Back: <span class="float-right">' + data.mi_selected_back + '</span></p>' + '<p>Bottom: <span class="float-right">' + data.mi_selected_bottom + '</span></p>');
        $('.fabric_shower').html(data.mi_selected_fabric);
        $('.fitting_shower').html(data.mi_selected_fits);
        $('.tall_weight_shower').html('<p>Tall: <span class="float-right">' + data.mi_selected_tall + '</span></p>' + '<p>Weight: <span class="float-right">' + data.mi_selected_weight + '</span></p>');
        $('.collar_shower').html(data.mi_selected_collar_size);
        $('.mi_final_price_shower').html(data.mi_total_price)
    }
    get_total_data(default_data);
    $('#sleeves_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('active').addClass('hide');
        $('.mi_shirt_front').removeClass('hide').addClass('active');
        if (itempart == 'long') {
            default_srcs.sleeves = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-long_353dbfdb-65f9-447a-88d7-97e16bf34abf.png?v=1678359974';
            default_srcs.back_type = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-long.png?v=1678270408';
            design_shirt(default_srcs);
            $('.cuff-element').removeClass('hide');
            $('.shirt_back_patch').removeClass('hide');
            default_data.mi_selected_sleeve = 'Long Sleeve'
        } else {
            default_srcs.sleeves = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-short.png?v=1678270215';
            default_srcs.back_type = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-short_30af5334-dbaa-4f56-8407-8db7c7c13e16.png?v=1678270408';
            design_shirt(default_srcs);
            $('.cuff-element').addClass('hide');
            $('.shirt_back_patch').addClass('hide');
            default_data.mi_selected_sleeve = 'Short Sleeve'
        }
    });
    $('#cuff_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_front').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('active').addClass('hide');
        $('.mi_shirt_cuff').removeClass('hide').addClass('active');
        if (itempart == 'onecuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/straight-one.jpg?v=1678348751';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Single Cuff'
        } else if (itempart == 'beveledcuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/beveled-one.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Single Beveled Cuff'
        } else if (itempart == 'roundededcuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/rounded-one.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Single Rounded Cuff'
        } else if (itempart == 'frenchcuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/french.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'French Cuff'
        } else if (itempart == 'twocuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/rounded-two.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Double Cuff'
        } else if (itempart == 'beveledtwocuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/beveled-two.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Double Beveled Cuff'
        } else if (itempart == 'roundedtwocuff') {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/rounded-two.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Double Rounded Cuff'
        } else {
            default_srcs.cuff = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/straight-one_eadd7f41-6e11-431b-a78b-fae3548676a2.jpg?v=1678355566';
            design_shirt(default_srcs);
            default_data.mi_selected_cuff = 'Single Cuff'
        }
    });
    $('#collar_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('active').addClass('hide');
        $('.mi_shirt_front').removeClass('hide').addClass('active');
        var itempart = $(this).attr('mi-target');
        if (itempart == 'classiccol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-classic_2d2ec775-b682-4e15-a7f0-f838d5efbb29.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Classic Collar'
        } else if (itempart == 'cutcol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-cutaway.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Cutaway Collar'
        } else if (itempart == 'excutcol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-extreme-cutaway.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Extreme Cutaway Collar'
        } else if (itempart == 'buttoncol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-button-down.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Button Collar'
        } else if (itempart == 'maocol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-mao-collar.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Mao Collar'
        } else if (itempart == 'wingcol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-wing-collar.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Wing Collar'
        } else if (itempart == 'clubcol') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-club-collar.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Club Collar'
        } else if (itempart == 'test') {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-club-collar.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Test Collar'
        } else {
            default_srcs.collar = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-classic_2d2ec775-b682-4e15-a7f0-f838d5efbb29.png?v=1678355723';
            design_shirt(default_srcs);
            default_data.mi_selected_collar = 'Classic Collar'
        }
    });
    $('#pocket_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('active').addClass('hide');
        $('.mi_shirt_front').removeClass('hide').addClass('active');
        if (itempart == 'leftpok') {
            default_srcs.pocket = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/left-pocket.png?v=1678367254';
            design_shirt(default_srcs);
            $('.custom_shirt.shirt_pocket').removeClass('hide');
            default_data.mi_selected_pocket = 'Left Pocket'
        } else if (itempart == 'twopok') {
            default_srcs.pocket = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/two-pockets.png?v=1678367254';
            design_shirt(default_srcs);
            $('.custom_shirt.shirt_pocket').removeClass('hide');
            default_data.mi_selected_pocket = 'Two Pocket'
        } else {
            default_srcs.pocket = 'nan';
            design_shirt(default_srcs);
            $('.custom_shirt.shirt_pocket').addClass('hide');
            default_data.mi_selected_pocket = 'No Pocket'
        }
    });
    $('#placket_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('active').addClass('hide');
        $('.mi_shirt_front').removeClass('hide').addClass('active');
        if (itempart == 'whiteplack') {
            default_srcs.placket = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-white.png?v=1678270215';
            design_shirt(default_srcs);
            default_data.mi_selected_placket = 'White Placket'
        } else if (itempart == 'hiddenplack') {
            default_srcs.placket = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-without-placket-hidden.png?v=1678366941';
            design_shirt(default_srcs);
            default_data.mi_selected_placket = 'Hidden Placket'
        } else {
            default_srcs.placket = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-white.png?v=1678270215';
            design_shirt(default_srcs);
            default_data.mi_selected_placket = 'White Placket'
        }
    });
    $('#back_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_front').removeClass('active').addClass('hide');
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('hide').addClass('active');
        if (itempart == 'boxplate') {
            default_srcs.back = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-box-pleats_df9d967e-350b-48b0-8371-1448a5e85770.png?v=1678367466';
            design_shirt(default_srcs);
            default_data.mi_selected_back = 'Box Pleats'
        } else if (itempart == 'sideplate') {
            default_srcs.back = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-side-pleats_a54d637b-46d2-4083-8524-5623cf3e0b5b.png?v=1678367466';
            design_shirt(default_srcs);
            default_data.mi_selected_back = 'Side Pleats'
        } else {
            default_srcs.back = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-no-pleats_9d43817a-bc8f-4a2e-a392-23cd3ecb6374.png?v=1678367394';
            design_shirt(default_srcs);
            default_data.mi_selected_back = 'No Pleats'
        }
    });
    $('#bottom_dropdown .mi_dropdown_item').on('click', function(e) {
        e.preventDefault();
        var itempart = $(this).attr('mi-target');
        $('.mi_shirt_front').removeClass('active').addClass('hide');
        $('.mi_shirt_cuff').removeClass('active').addClass('hide');
        $('.mi_shirt_back').removeClass('hide').addClass('active');
        if (itempart == 'tail') {
            default_srcs.bottom = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-square_553fe3e8-5559-4ff4-8a2d-767e5a9af99e.png?v=1678368812';
            design_shirt(default_srcs);
            default_data.mi_selected_bottom = 'Tail Bottom'
        } else if (itempart == 'square') {
            default_srcs.bottom = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-tail_a137897d-6af2-494d-ad21-372ecd9346a0.png?v=1678367934';
            design_shirt(default_srcs);
            default_data.mi_selected_bottom = 'Square Bottom'
        } else {
            default_srcs.bottom = 'https://cdn.shopify.com/s/files/1/0733/9101/4200/files/white-square_553fe3e8-5559-4ff4-8a2d-767e5a9af99e.png?v=1678368812';
            design_shirt(default_srcs);
            default_data.mi_selected_bottom = 'Tail Bottom'
        }
    });
    $('.mi_sidebar_toggle').on('click', function(e) {
        e.preventDefault();
        $('.mi_sidebar_floating').toggle('left')
    })
    $('.mi_sidebar_toggle_dismiss').on('click', function(e) {
        e.preventDefault();
        $('.mi_sidebar_floating').hide('slow')
    })
    $('#mi_next_to_choose_cloth_and_sizes').on('click', function(e) {
        e.preventDefault();
        $('#mi_main_design_area').addClass('hide').removeClass('active');
        $('#mi_choose_cloth_and_size_area').addClass('active').removeClass('hide')
    })
    $('#mi_back_to_main_designs').on('click', function(e) {
        e.preventDefault();
        $('#mi_choose_cloth_and_size_area').removeClass('active').addClass('hide');
        $('#mi_main_design_area').removeClass('hide').addClass('active')
    })
    $('#mi_next_to_choose_fits').on('click', function(e) {
        e.preventDefault();
        $('#mi_choose_cloth_and_size_area').addClass('hide').removeClass('active');
        $('#mi_fittings_choose').removeClass('hide').addClass('active')
    })
    $('#mi_back_to_choose_fabrics').on('click', function(e) {
        e.preventDefault();
        $('#mi_fittings_choose').addClass('hide').removeClass('active');
        $('#mi_choose_cloth_and_size_area').removeClass('hide').addClass('active')
    })
    $('#mi_back_to_choose_fits').on('click', function(e) {
        e.preventDefault();
        $('#mi_info_choose').removeClass('active').addClass('hide');
        $('#mi_fittings_choose').removeClass('hide').addClass('active')
    })
    $('#mi_next_to_add_details').on('click', function(e) {
        e.preventDefault();
        $('#mi_fittings_choose').addClass('hide').removeClass('active');
        $('#mi_info_choose').removeClass('hide').addClass('active')
    })
    $('.cloth_elements .cloth_el img').on('click', function(e) {
        e.preventDefault();
        var get_parent = $(this).parent('li.cloth_el');
        var imgSrc = $(this).attr('src');
        $('.cloth_elements .cloth_el').removeClass('mi_selected_option');
        get_parent.addClass('mi_selected_option');
        $('.mi_fabric_previewer img').attr('src', imgSrc);
        var get_name = get_parent.find('small').text();
        default_data.mi_selected_fabric = get_name
    })
    $('.fits_elements .fit_el img').on('click', function(e) {
        e.preventDefault();
        var get_parent = $(this).parent('li.fit_el');
        $('.fits_elements .fit_el').removeClass('mi_selected_option');
        get_parent.addClass('mi_selected_option');
        var get_name = get_parent.find('p.text-uppercase').text();
        default_data.mi_selected_fits = get_name
    })
    $('button.mi_minus').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('mi-target');
        var current = parseInt($('#' + target).val());
        if (current >= 2) {
            $('#' + target).val(current - 1)
        } else {
            console.log('Invalid Value')
        }
    });
    $('button.mi_plus').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('mi-target');
        var current = parseInt($('#' + target).val());
        if (current < 12) {
            $('#' + target).val(current + 1)
        } else {
            console.log('Invalid Value')
        }
    });
    $('button.mi_minus2').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('mi-target');
        var current = parseInt($('#' + target).val());
        if (current >= 2) {
            $('#' + target).val(current - 1)
        } else {
            console.log('Invalid Value')
        }
    });
    $('button.mi_plus2').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('mi-target');
        var current = parseInt($('#' + target).val());
        if (current < 100) {
            $('#' + target).val(current + 1)
        } else {
            console.log('Invalid Value')
        }
    });
    $('#mi_next_to_review_total').on('click', function(e) {
        e.preventDefault();
        $('#mi_info_choose').addClass('hide').removeClass('active');
        $('#mi_info_review').addClass('active').removeClass('hide');
        default_data.mi_selected_tall = $('#choose_talls_feet').val() + ' feet - ' + $('#choose_talls_inch').val() + ' inch';
        default_data.mi_selected_weight = $('#choose_weight_kg').val() + ' Kg';
        default_data.mi_selected_collar_size = $('#choose_collar_size').val() + ' inch';
        default_data.mi_total_price = 'Rs 2,000';
        get_total_data(default_data)
    });
    $('#mi_back_to_design').on('click', function(e) {
        e.preventDefault();
        $('#mi_info_review').addClass('hide').removeClass('active');
        $('#mi_main_design_area').addClass('active').removeClass('hide')
    });
    $('#complete_order').on('click', function(e) {
        e.preventDefault();
        console.log(default_data);
        alert(JSON.stringify(default_data));
        window.location = "/"
    })
})(jQuery);